import React from "react";
import PropTypes from "prop-types";
import OvInfoCard from "./OvInfoCard";
import OvTimeInfoContent from "./OvTimeInfoContent";
import OvTimeInfoActionsContainer from "./OvTimeInfoActionsContainer";
import OvTimeInfoTable from "./OvTimeInfoTable";

const OvTimeInfoCard = props => {
  return (
    <div style={{ display: props.monitoringMode ? "none" : "block" }}>
      <OvInfoCard
        loading={props.loading}
        title="Usage over time"
        content={<OvTimeInfoContent {...props} />}
        actions={<OvTimeInfoActionsContainer {...props} />}
        expandedContent={<OvTimeInfoTable {...props} />}
        expandLabel="Table"
        contractLabel="Hide table"
      />
    </div>
  );
};

OvTimeInfoCard.propTypes = {
  granularity: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default OvTimeInfoCard;



// WEBPACK FOOTER //
// ./src/OvTimeInfoCard.js